module.exports = __webpack_public_path__ + "static/boston-globe-6cbb5d203783799e12025fc95f9749cb.jpg";